// extracted by mini-css-extract-plugin
module.exports = {"interface":"SettingInterfaceDocx_interface__3BM-X","contents":"SettingInterfaceDocx_contents__37E00"};